/*
 * resetPinEproDevicePopupComponent
 * */

import templateUrl from './resetPinEproDevicePopup.html';
import controller from './resetPinEproDevicePopup.controller';
import './resetPinEproDevicePopup.scss';

const resetPinEproDevicePopupComponent = {
	bindings: {
		componentReady: '&'
	},
	templateUrl,
	controller
};

export default resetPinEproDevicePopupComponent;
